import qs from 'qs';
import api from '../../utils/api';
import { Pagination, Role, SelectItem } from '~/types';
import { PAGE_SIZE } from '~/constants';

export async function getRoles(): Promise<Pagination<Role>> {
  const { data } = await api.get<Pagination<Role>>('/funcoes');
  return data;
}

export async function getInternalRoles(): Promise<Pagination<Role>> {
  const { data } = await api.get<Pagination<Role>>('/funcoes/internos');
  return data;
}

export async function getInternalRolesWithoutAdministratorOrClient(
  pageSize: number = PAGE_SIZE,
): Promise<SelectItem[]> {
  const { data } = await api.get<Pagination<Role>>(
    '/funcoes/funcoes-sem-administrador-ou-cliente',
    {
      params: {
        size: pageSize,
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    },
  );

  return data.results.map(role => {
    return { label: role.nm_funcao, value: role.id_funcao.toString() };
  });
}
export async function getExternalRoles(): Promise<Pagination<Role>> {
  const { data } = await api.get<Pagination<Role>>('/funcoes/externos');
  return data;
}
